var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { EventBusEvent } from '../enums/EventBus';
import EventBus from '../event-bus/EventBus';
import { LocaleProvider, useLocalization } from '../providers/LocaleProvider';
import { useKeyboardClose } from './keyboard';
var eventBus = new EventBus();
export var useGetOpenDisclaimer = function () {
    var _a = useLocalization(), locale = _a.locale, locales = _a.locales;
    return function (eventData) {
        eventBus.emit(EventBusEvent.ToggleDisclaimer, __assign(__assign({ open: true }, eventData), (eventData.content && {
            content: (React.createElement(LocaleProvider, { locale: locale, locales: locales[locale] }, eventData.content)),
        })));
    };
};
export var useOpenDisclaimer = function (eventData, shouldPreventDefaultBehavior) {
    var toggleDisclaimer = useGetOpenDisclaimer();
    return useCallback(function (event) {
        if (shouldPreventDefaultBehavior && event) {
            event.preventDefault();
        }
        toggleDisclaimer(eventData);
    }, [eventData]);
};
export var useCloseDrawer = function (toggleEvent) {
    var closeDrawer = useCallback(function () {
        eventBus.emit(toggleEvent, { open: false });
    }, []);
    useKeyboardClose(true, closeDrawer);
    return closeDrawer;
};
